<template>

    <div class="w_inner">
        <div class="MProShowType">
        <div class="con_box inner_banner product wow fadeIn animated" data-wow-delay="0.0s"
            :style="{ 'background-image': 'url(' + dto.imgBg + ')' }">
            <div class="text_conShow">
                <div class="text_box">
                    <div v-if="currentLang == 'zh'" class="title wow fadeInUp animated" data-wow-delay="0.2s">
                        {{ dto.title }}</div>
                    <div v-else class="title wow fadeInUp animated" data-wow-delay="0.2s">{{ dto.enTitle }}</div>
                    <div v-if="currentLang == 'zh'" class="con wow fadeInUp animated" data-wow-delay="0.3s"
                        v-html="utils.ShowContentBr(dto.content)"></div>
                    <div v-else class="con wow fadeInUp animated" data-wow-delay="0.3s"
                        v-html="utils.ShowContentBr(dto.enContent)"></div>
                </div>
            </div>
        </div>
        <div class="innerWrap">
            <div class="main_container">
                <div class="title wow fadeInUp animated" data-wow-delay=".2s">{{ $t('product.title') }}</div>
                <div class="pro_list">
                    <div class="list clearfix">
                        <ul>
                            <template v-for="(item, index) in pro_list">
                                <li :key="index" class="wow fadeIn animated" data-wow-delay="0.3s">
                                    <router-link :to="{ name: 'productdetail', params: { id: item.id } }">
                                        <div class="bgImg">
                                            <img :src="item.imgUrl">
                                        </div>
                                        <div class="pro_textCon">
                                            <div class="name">{{ item.title }}</div>
                                            <div class="tip">{{ item.subTitle }}</div>
                                        </div>
                                    </router-link>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>

</template>

<script>
import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
    data() {
        return {
            id: this.$route.params.id,
            dto: {},
            pro_list: {},
            currentLang: this.$i18n.locale
        }
    },
    mounted() {
        //滚动页面加载动画
        let wow = new WOW.WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
        document.documentElement.scrollTop = 0;
    },

    created: function () {
        this.GetCat();
        this.GetProList();
    },
    components: {

    },
    methods: {
        GetCat() {
            var url = "/pageapi/Product/GetCat";
            this.$http.post(url, { id: this.$route.params.id }).then(function (res) {
                if (res.data.status == 1 && res.data.ds.length > 0) {
                    this.dto = res.data.ds[0];
                }
            }.bind(this)).catch(function () {
            });
        },
        GetProList() {
            var url = "/pageapi/Product/GetList";
            this.$http.post(url, { CategoryId: this.id }).then(function (res) {
                if (res.data.status == 1) {
                    this.pro_list = res.data.ds;
                    this.$nextTick(function () {
                        this.Initwow();
                    });
                }
            }.bind(this)).catch(function () {
            });
        },
        Initwow() {
            let wow = new WOW.WOW({
                boxClass: "wow",
                animateClass: "animated",
                offset: 0,
                mobile: true,
                live: true
            });
            wow.init();
        }
    },
    watch: {
        $route(newVal, oldVal) {
            this.id = this.$route.params.id;
            this.GetCat();
            this.GetProList();
        }
    }
};
</script>
